module.exports = __webpack_public_path__ + "assets/img/b5aa6ad86f68490050a3f296e4cd3a41.svg";